export default {"src":"/_next/static/media/menu-cars.a0034fca.svg","height":18,"width":20};